const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL;
const SCRIPT_SRC = "https://assets.calendly.com/assets/external/widget.js";
const CSS_HREF = "https://assets.calendly.com/assets/external/widget.css";

let loader;

const loadCalendly = () => {
  if (window.Calendly) return Promise.resolve();
  if (loader) return loader;
  const css = document.createElement("link");
  css.rel = "stylesheet";
  css.href = CSS_HREF;
  document.head.appendChild(css);
  loader = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.async = true;
    s.onload = resolve;
    s.onerror = () => {
      loader = null;
      reject();
    };
    document.body.appendChild(s);
  });
  return loader;
};

export const openCalendly = () =>
  loadCalendly()
    .then(() => window.Calendly.initPopupWidget({ url: CALENDLY_URL }))
    .catch(() => window.open(CALENDLY_URL, "_blank", "noopener"));
